/* asc-prod.js: non-dock product pages (products workstream, 2026-10 rebuild).
   Gallery, variant choice (tray by SKU: CT-<size>-<colour>-; others by option values), add to cart through
   window.ascCart (cart contract v1), with a /cart/add.js fallback. Logic never keys on variant titles. */
(function () {
  'use strict';

  function addToCart(items) {
    var opts = { open: true, source: 'products' };
    if (window.ascCart && typeof window.ascCart.add === 'function') return window.ascCart.add(items, opts);
    return new Promise(function (resolve, reject) {
      var done = false;
      window.ascCartQueue = window.ascCartQueue || [];
      window.ascCartQueue.push(function (api) {
        if (done) return; done = true;
        api.add(items, opts).then(resolve, reject);
      });
      // Fallback if the cart API never loads: plain AJAX add, then ask the drawer to open.
      setTimeout(function () {
        if (done) return; done = true;
        fetch('/cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error(res.j.description || res.j.message || 'Error');
            document.dispatchEvent(new CustomEvent('asc:cart:open'));
            resolve(res.j);
          }).catch(reject);
      }, 3500);
    });
  }

  function init(root) {
    if (root.__ascInit) return; root.__ascInit = true;
    var dataEl = root.querySelector('[data-asc-variants]');
    if (!dataEl) return;
    var data = JSON.parse(dataEl.textContent);
    var mode = root.dataset.mode;
    var variants = data.variants;
    var current = variants.filter(function (v) { return v.id === data.current; })[0] || variants[0];
    var $ = function (s) { return root.querySelector(s); };
    var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };

    /* ---------- Gallery ---------- */
    var stage = $('[data-asc-stage]');
    var thumbs = $('[data-asc-thumbs]');
    var count = $('[data-asc-count]');
    function slides() { return stage ? $$('.asc-prod__slide').filter(function (s) { return !s.hidden; }) : []; }
    function activeIndex() {
      var list = slides(); if (!list.length) return 0;
      var x = stage.scrollLeft, w = stage.clientWidth;
      return Math.max(0, Math.min(list.length - 1, Math.round(x / w)));
    }
    function goTo(i, smooth) {
      var list = slides(); if (!list.length) return;
      i = (i + list.length) % list.length;
      stage.scrollTo({ left: list[i].offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
      markThumb(i);
    }
    function markThumb(i) {
      if (count) count.textContent = (i + 1) + ' / ' + slides().length;
      if (!thumbs) return;
      $$('.asc-prod__thumb').forEach(function (t, k) { t.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
    }
    function buildThumbs() {
      if (!thumbs) return;
      thumbs.innerHTML = '';
      var list = slides();
      root.classList.toggle('asc-prod--single', list.length < 2);
      list.forEach(function (s, k) {
        var img = s.querySelector('img');
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'asc-prod__thumb'; b.setAttribute('role', 'tab');
        b.setAttribute('aria-label', 'Image ' + (k + 1));
        if (img) {
          var t = document.createElement('img');
          var src = img.currentSrc || img.src;
          t.src = src.replace(/width=\d+/, 'width=200'); t.alt = ''; t.loading = 'lazy'; t.width = 72; t.height = 72;
          b.appendChild(t);
        } else { b.textContent = '▶'; }
        b.addEventListener('click', function () { goTo(k); });
        thumbs.appendChild(b);
      });
      markThumb(activeIndex());
    }
    if (stage) {
      var raf;
      stage.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(function () { markThumb(activeIndex()); }); }, { passive: true });
      stage.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); goTo(activeIndex() + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(activeIndex() - 1); }
      });
      var prev = $('[data-asc-prev]'), next = $('[data-asc-next]');
      if (prev) prev.addEventListener('click', function () { goTo(activeIndex() - 1); });
      if (next) next.addEventListener('click', function () { goTo(activeIndex() + 1); });
      buildThumbs();
    }
    function showVariantMedia(v, jump) {
      if (!stage) return;
      var own = $$('[data-variant-media]');
      if (mode === 'tray' || mode === 'gift') {
        own.forEach(function (s) { s.hidden = String(s.dataset.variantMedia) !== String(v.id); });
        buildThumbs();
      }
      if (!jump) return;
      var list = slides();
      var target = list.findIndex(function (s) { return String(s.dataset.variantMedia) === String(v.id); });
      if (target < 0 && v.media) target = list.findIndex(function (s) { return String(s.dataset.mediaId) === String(v.media); });
      if (target >= 0) goTo(target, true);
    }

    /* ---------- Variant state ---------- */
    var idInput = $('[data-asc-id]');
    var priceEls = $$('[data-asc-price], [data-asc-atc-price], [data-asc-sticky-price]');
    var atc = $('[data-asc-atc]'), atcLabel = $('[data-asc-atc-label]');
    var stickyAtc = $('[data-asc-sticky-atc]'), stickyVariant = $('[data-asc-sticky-variant]');
    var stock = $('[data-asc-stock]'), stockText = $('[data-asc-stock-text]');
    var errorEl = $('[data-asc-error]');

    function setVariant(v, jump) {
      if (!v) return;
      current = v;
      if (idInput) idInput.value = v.id;
      priceEls.forEach(function (el) { el.textContent = v.price; });
      [atc, stickyAtc].forEach(function (b) { if (b) b.disabled = !v.available; });
      if (atcLabel) atcLabel.textContent = v.available ? data.text.atc : data.text.soldOut;
      if (stock && stockText) { stockText.textContent = v.available ? stock.dataset.in : stock.dataset.out; stock.classList.toggle('is-out', !v.available); }
      if (stickyVariant && mode !== 'gift' && !data.onlyDefault) stickyVariant.textContent = v.title;
      if (errorEl) errorEl.hidden = true;
      try {
        var u = new URL(window.location.href); u.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', u.toString());
      } catch (e) {}
      showVariantMedia(v, jump);
      if (mode === 'tray') trayUI();
      var art = $('[data-asc-giftart-amount]'); if (art && v.short) { art.textContent = v.short; var box = $('[data-asc-giftart]'); if (box) box.setAttribute('aria-label', box.getAttribute('aria-label').replace(/,[^,]*$/, ', ' + v.short)); }
    }

    /* Tray: size and colour come from the SKU (CT-<S|M|L|XL>-<B|W>-…). */
    function skuPart(v, i) { return (v.sku || '').split('-')[i] || ''; }
    function trayFind(size, color) {
      return variants.filter(function (v) { return skuPart(v, 0) === 'CT' && skuPart(v, 1) === size && skuPart(v, 2) === color; })[0];
    }
    var deskResult = $('[data-asc-desk-result]');
    function trayUI() {
      var size = skuPart(current, 1), color = skuPart(current, 2);
      $$('[data-size]').forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.size === size ? 'true' : 'false'); });
      $$('[data-color]').forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.color === color ? 'true' : 'false'); });
      var btn = root.querySelector('[data-size="' + size + '"]');
      if (deskResult && btn) {
        var name = btn.dataset.sizeName || '';
        // "[desk]" = that size's desk range from its button: "57 to 76 in (145 to 193 cm)", "under 39 in (99 cm)", "77 in (196 cm) and wider"
        var dIn = btn.querySelector('.asc-prod__desk-in'), dCm = btn.querySelector('.asc-prod__desk-cm');
        var tIn = (dIn ? dIn.textContent : '').trim(), tCm = (dCm ? dCm.textContent : '').trim();
        var plus = /\+\s*$/.test(tIn);
        tIn = tIn.replace(/\s*\+\s*$/, '').replace(/^Under /i, 'under ');
        tCm = tCm.replace(/\s*\+\s*$/, '').replace(/^under /i, '');
        var desk = (tIn + (tCm ? ' (' + tCm + ')' : '') + (plus ? ' and wider' : '')).replace(/</g, '&lt;');
        deskResult.innerHTML = '<span aria-hidden="true">→</span> ' + data.text.fits.replace('[size]', '<strong>' + name.replace(/</g, '&lt;') + '</strong>').replace('[desk]', desk);
      }
    }
    if (mode === 'tray') {
      $$('[data-size]').forEach(function (b) {
        b.addEventListener('click', function () { setVariant(trayFind(b.dataset.size, skuPart(current, 2)) || current, true); });
      });
      $$('[data-color]').forEach(function (b) {
        b.addEventListener('click', function () { setVariant(trayFind(skuPart(current, 1), b.dataset.color) || current, true); });
      });
      // A ?variant= that is not a tray SKU (or no variant) falls back to the server's choice.
      trayUI();
    }

    /* Accessories and gift card: option buttons. */
    if (mode === 'accessory' || mode === 'gift') {
      $$('[data-asc-option]').forEach(function (fs) {
        var pos = parseInt(fs.dataset.ascOption, 10) - 1;
        fs.querySelectorAll('.asc-prod__chip').forEach(function (b) {
          b.addEventListener('click', function () {
            var wanted = current.options.slice(); wanted[pos] = b.dataset.value;
            var match = variants.filter(function (v) { return v.options.every(function (o, k) { return o === wanted[k]; }); })[0]
              || variants.filter(function (v) { return v.options[pos] === b.dataset.value; })[0];
            fs.querySelectorAll('.asc-prod__chip').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
            if (match) {
              setVariant(match, true);
              // keep the other groups in sync with the matched variant
              $$('[data-asc-option]').forEach(function (g) {
                var p2 = parseInt(g.dataset.ascOption, 10) - 1;
                g.querySelectorAll('.asc-prod__chip').forEach(function (x) { x.setAttribute('aria-pressed', x.dataset.value === match.options[p2] ? 'true' : 'false'); });
              });
            }
          });
        });
      });
    }

    /* ---------- Gift: custom amount = one of the product's own variants (variant grid) ---------- */
    var custom = $('[data-asc-custom]');
    if (custom) {
      var cin = custom.querySelector('[data-asc-custom-input]'), chelp = custom.querySelector('[data-asc-custom-help]');
      var step = parseFloat(custom.dataset.step) || 5;
      var pick = function () {
        var raw = (cin.value || '').trim();
        custom.classList.remove('is-error');
        if (chelp) chelp.textContent = chelp.dataset.text;
        if (!raw) return true;
        var cents = Math.round(parseFloat(raw.replace(',', '.')) * 100);
        var match = variants.filter(function (v) { return !v.hidden && v.available && v.cents === cents; })[0];
        if (!match) {
          custom.classList.add('is-error');
          if (chelp) chelp.textContent = (data.text.customErr || '').replace('[min]', cin.min).replace('[max]', cin.max).replace('[step]', step);
          return false;
        }
        $$('.asc-prod__chip--amount').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
        setVariant(match, true);
        return true;
      };
      cin.addEventListener('change', pick);
      cin.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); pick(); } });
      $$('.asc-prod__chip--amount').forEach(function (b) { b.addEventListener('click', function () { cin.value = ''; custom.classList.remove('is-error'); if (chelp) chelp.textContent = chelp.dataset.text; }); });
      root.__ascCustomPick = pick;
    }

    /* ---------- Gift: send by email ---------- */
    var giftToggle = $('[data-asc-gift-toggle]'), giftFields = $('[data-asc-gift-fields]');
    if (giftToggle && giftFields) {
      giftToggle.addEventListener('change', function () { giftFields.hidden = !giftToggle.checked; });
      var d = $('[data-asc-gift-date]');
      if (d) {
        var t = new Date(); var pad = function (n) { return (n < 10 ? '0' : '') + n; };
        d.min = t.getFullYear() + '-' + pad(t.getMonth() + 1) + '-' + pad(t.getDate());
        var m = new Date(t.getTime() + 89 * 864e5);
        d.max = m.getFullYear() + '-' + pad(m.getMonth() + 1) + '-' + pad(m.getDate());
      }
    }
    function giftProps() {
      if (!giftToggle || !giftToggle.checked) return null;
      var email = ($('[data-asc-gift-email]').value || '').trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { showError(data.text.giftEmail); $('[data-asc-gift-email]').focus(); return false; }
      var props = { 'Recipient email': email, __shopify_send_gift_card_to_recipient: 'on', __shopify_offset: String(new Date().getTimezoneOffset()) };
      var name = ($('[data-asc-gift-name]').value || '').trim(); if (name) props['Recipient name'] = name;
      var msg = ($('[data-asc-gift-message]').value || '').trim(); if (msg) props['Message'] = msg;
      var date = ($('[data-asc-gift-date]').value || '').trim(); if (date) props['Send on'] = date;
      return props;
    }

    /* ---------- Add to cart ---------- */
    function showError(msg) { if (errorEl) { errorEl.textContent = msg; errorEl.hidden = false; } }
    var busy = false;
    function submit(e) {
      if (e) e.preventDefault();
      if (busy || !current || !current.available || !data.sellable) return;
      var item = { id: current.id, quantity: 1 };
      if (mode === 'gift' && root.__ascCustomPick && !root.__ascCustomPick()) { (root.querySelector('[data-asc-custom-input]') || {}).focus && root.querySelector('[data-asc-custom-input]').focus(); return; }
      if (mode === 'gift') {
        var props = giftProps();
        if (props === false) return;
        if (props) item.properties = props;
      }
      busy = true;
      root.classList.add('is-adding');
      [atc, stickyAtc].forEach(function (b) { if (b) b.setAttribute('aria-busy', 'true'); });
      addToCart([item]).then(function () {
        if (errorEl) errorEl.hidden = true;
      }).catch(function (err) {
        var msg = err && err.message;
        // Network/timeouts read badly ("signal is aborted…", "Failed to fetch"): show the plain message instead.
        if (!msg || (err && err.name === 'AbortError') || /abort|failed to fetch|load failed|network/i.test(msg)) msg = data.text.error;
        showError(msg);
      }).then(function () {
        busy = false; root.classList.remove('is-adding');
        [atc, stickyAtc].forEach(function (b) { if (b) b.removeAttribute('aria-busy'); });
      });
    }
    var form = $('[data-asc-form]');
    if (form) form.addEventListener('submit', submit);
    if (stickyAtc) stickyAtc.addEventListener('click', submit);

    /* ---------- Sticky bar on phones/tablets: only while the main button is out of view ---------- */
    var sticky = $('[data-asc-sticky]');
    if (sticky && atc && 'IntersectionObserver' in window) {
      var mq = window.matchMedia('(max-width: 989px)');
      var io = new IntersectionObserver(function (entries) {
        var en = entries[0];
        // Only after the main button has scrolled up out of view: never on the first screen, never over the options.
        sticky.hidden = !(mq.matches && !en.isIntersecting && en.boundingClientRect.top < 0);
      });
      io.observe(atc);
    }
  }

  // Pages whose Loox reviews aren't the product's own: no AggregateRating in structured data (see asc-prod-main).
  function stripRating() {
    if (!document.querySelector('[data-asc-no-rating]')) return;
    document.querySelectorAll('script[type="application/ld+json"]').forEach(function (el) {
      try {
        var j = JSON.parse(el.textContent);
        if (j && j.aggregateRating) {
          if ((j['@type'] === 'Product' || j['@type'] === 'ProductGroup') && Object.keys(j).length <= 4 && !j.offers && !j.sku) { el.remove(); return; }
          delete j.aggregateRating; el.textContent = JSON.stringify(j);
        }
      } catch (e) {}
    });
  }
  window.addEventListener('DOMContentLoaded', function () { setTimeout(stripRating, 0); });
  window.addEventListener('load', function () { stripRating(); setTimeout(stripRating, 1500); });

  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-asc-prod]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
